import { Button, Tab, Tabs } from '@mui/material';
import classNames from 'classnames';

import { FormSelectCustom } from '@/components';
import type { PropertyKindEnum } from '@/types';

import styles from './AdsFilters.module.scss';

interface PropertyKindOption {
  label: string;
  value: PropertyKindEnum;
}

interface PropertyKindSelectorProps {
  onPropertyKindChange: (value: PropertyKindEnum) => void;
  onTabChange: (value: number) => void;
  options: PropertyKindOption[];
  propertyTypeTab: number;
  selectedPropertyKinds: PropertyKindEnum[];
  valueLabel: string;
}

export const PropertyKindSelector = ({
  onPropertyKindChange,
  onTabChange,
  options,
  propertyTypeTab,
  selectedPropertyKinds,
  valueLabel,
}: PropertyKindSelectorProps) => (
  <div className={styles.propertyKindControl}>
    <FormSelectCustom label='' value={valueLabel} textCapitalize={false}>
      <div className={styles.floor}>
        <Tabs
          value={propertyTypeTab}
          onChange={(_, value) => onTabChange(value)}
          aria-label='property type tabs'
          className={styles.tabsContainer}
        >
          <Tab
            label='Residential'
            id='property-type-tab-0'
            aria-controls='property-type-tabpanel-0'
            className={styles.tabItem}
          />
          <Tab
            label='Commercial'
            id='property-type-tab-1'
            aria-controls='property-type-tabpanel-1'
            className={styles.tabItem}
          />
        </Tabs>
        {propertyTypeTab === 0 && (
          <div
            role='tabpanel'
            hidden={propertyTypeTab !== 0}
            id='property-type-tabpanel-0'
            aria-labelledby='property-type-tab-0'
            className={styles.buttonsContainer}
          >
            <div>
              {[0, 1, 2, 3].map((index) => (
                <Button
                  key={options[index].value}
                  className={classNames({
                    [styles.selectButtons]: true,
                    [styles.propertyKindButton]: true,
                    [styles.selectButtonsActive]: selectedPropertyKinds.includes(
                      options[index].value
                    ),
                  })}
                  variant='contained'
                  onClick={() => onPropertyKindChange(options[index].value)}
                >
                  {options[index].label}
                </Button>
              ))}
            </div>
            <div>
              {[4, 5, 6, 7].map((index) => (
                <Button
                  key={options[index].value}
                  className={classNames({
                    [styles.selectButtons]: true,
                    [styles.propertyKindButton]: true,
                    [styles.selectButtonsActive]: selectedPropertyKinds.includes(
                      options[index].value
                    ),
                  })}
                  variant='contained'
                  onClick={() => onPropertyKindChange(options[index].value)}
                >
                  {options[index].label}
                </Button>
              ))}
            </div>
          </div>
        )}
        {propertyTypeTab === 1 && (
          <div
            role='tabpanel'
            hidden={propertyTypeTab !== 1}
            id='property-type-tabpanel-1'
            aria-labelledby='property-type-tab-1'
            className={styles.buttonsContainer}
          >
            <div>
              {[8, 9, 10].map((index) => (
                <Button
                  key={options[index].value}
                  className={classNames({
                    [styles.selectButtons]: true,
                    [styles.propertyKindButton]: true,
                    [styles.selectButtonsActive]: selectedPropertyKinds.includes(
                      options[index].value
                    ),
                  })}
                  variant='contained'
                  onClick={() => onPropertyKindChange(options[index].value)}
                >
                  {options[index].label}
                </Button>
              ))}
            </div>
            <div>
              {[11, 12, 13].map((index) => (
                <Button
                  key={options[index].value}
                  className={classNames({
                    [styles.selectButtons]: true,
                    [styles.propertyKindButton]: true,
                    [styles.selectButtonsActive]: selectedPropertyKinds.includes(
                      options[index].value
                    ),
                  })}
                  variant='contained'
                  onClick={() => onPropertyKindChange(options[index].value)}
                >
                  {options[index].label}
                </Button>
              ))}
            </div>
          </div>
        )}
      </div>
    </FormSelectCustom>
  </div>
);
